exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.responsive_modal .ant-modal-content {\n  height: 90vh !important;\n  overflow: auto !important;\n}\n", ""]);

// exports
